export function stringCroppedView(string, length = 15) {
  if (string === null || string === undefined || string === '') return
  const strValue = String(string)
  return strValue.length > length
    ? strValue.substring(0, length) + '...'
    : strValue
}
